/**
 * Hook for fetching recent tasks for the dashboard.
 * @module hooks
 */

import { dashboardService } from '@/services/api';
import type { RecentTask } from '@/pages/DashboardPage/components/CompactTaskRow/CompactTaskRow.types';
import { useDashboardQuery } from './useDashboardQuery';

const FETCHER = () => dashboardService.getRecentTasks();

export function useDashboardRecentTasks() {
  const { data, isLoading, error, refresh } = useDashboardQuery<RecentTask[]>(
    FETCHER,
    'Failed to fetch recent tasks'
  );
  return {
    recentTasks: data ?? [],
    isLoading,
    error,
    refresh,
  };
}
